import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-alphanumeric-keypad',
  templateUrl: './alphanumeric-keypad.component.html',
  styleUrls: ['./alphanumeric-keypad.component.scss'],
})
export class AlphanumericKeypadComponent {
  @Output() keyPress = new EventEmitter<string>();
  @Output() space = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
  @Output() backspace = new EventEmitter<void>();

  @Output() focusUp = new EventEmitter<void>();
  @Output() focusRight = new EventEmitter<void>();
  @Output() focusDown = new EventEmitter<void>();
  @Output() focusLeft = new EventEmitter<void>();

  isBackFocused = false;
  isSymbolsLayout = false;
  readonly keys: string[][] = [
    ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'BACK'],
    ['J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R'],
    ['S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1'],
    ['2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['SPACE', 'CLEAR'],
  ];

  onKeyClick(key: string) {
    if (key === 'BACK') {
      this.backspace.emit();
    } else if (key === 'SPACE') {
      this.space.emit();
    } else if (key === 'CLEAR') {
      this.clear.emit();
    } else {
      this.keyPress.emit(key);
    }
  }

  setFocus(key: string) {
    this.isBackFocused = key === 'BACK';
  }

  /**
   * Handles all arrow key navigation events
   */
  onKeyDown(event: KeyboardEvent, i: number, j: number): void {
    if (event.isUp()) {
      if (i === 0) {
        this.focusUp.emit();
      }
    } else if (event.isDown()) {
      if (i === this.keys.length - 1) {
        this.focusDown.emit();
      }
    } else if (event.isLeft()) {
      if (j === 0) {
        this.focusLeft.emit();
        event.stopPropagation();
      }
    } else if (event.isRight()) {
      const rowLength = this.keys[i].length;
      if (j === rowLength - 1) {
        this.focusRight.emit();
        event.stopPropagation();
      }
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
